import { createContext, useContext } from 'react';
import { Paths } from 'talent_matching/types';

type CalibrationModalContextType = {
  openCalibrationModal: () => void;
  closeCalibrationModal: () => void;
  showCalibrationModal: boolean;
  paths: Paths;
  jobTitle: string;
  canCreateCalibrationSetting: boolean;
  canEditAndDeleteTalentMatchingCalibration: boolean;
};

// eslint-disable-next-line @typescript-eslint/no-empty-function
const noop = () => {};

const CalibrationModalContext = createContext<CalibrationModalContextType>({
  openCalibrationModal: noop,
  closeCalibrationModal: noop,
  showCalibrationModal: false,
  paths: {} as Paths,
  jobTitle: '',
  canCreateCalibrationSetting: false,
  canEditAndDeleteTalentMatchingCalibration: false,
});

export const useCalibrationModal = () => useContext(CalibrationModalContext);
export const CalibrationModalProvider = CalibrationModalContext.Provider;
